
const convertImageToBase64 = async (imageUrl) => {
    try {
      // Hacer la petición para obtener la imagen
      const response = await fetch(imageUrl);
      
      // Verificar si la petición fue exitosa
      if (!response.ok) {
        console.log(`Error al cargar la imagen: ${response.status} ${response.statusText}`);
      }
      
      // Obtener los datos de la imagen como un blob
      const blob = await response.blob();
      
      // Convertir el blob a base64
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          // El resultado ya está en formato base64
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error al convertir la imagen a base64:', error);
      throw error; // Relanzar el error para manejarlo donde se llame a la función
    }
};

export default convertImageToBase64;